// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2VM_G","title":"AfterBackImages_title__2Y-Go","images":"AfterBackImages_images__1_k2O"};